import React from "react";

// =====================================================================
// Club Radar V2 — verbatim symbol library (DESIGN-SPEC.md §3).
// Brief Rule 2 — ZERO TOLERANCE: every SVG below is copied 1:1 from the
// handoff `Club Radar.dc.html`; never swapped for a look-alike platform
// icon. Size variants are exactly the ones the frames use (identical
// viewBox/paths, only width/height vary).
//
// The country FLAG is NOT here — Brief Rule 3 mandates the platform's
// image-flag idiom (see FlagChip.jsx); the artboard's CSS-gradient
// chips are sample rendering only and must never ship.
// =====================================================================

// S1 — Search magnifier (search fields: 1a/1b/1c/1d/1n, 2a/2b member
// search). Rendered 13×13 desktop / 12×12 mobile (2b).
export const SearchGlyph = ({ size = 13, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true" {...rest}>
    <circle cx="6" cy="6" r="4.5" stroke="#9CA3AF" strokeWidth="1.5" fill="none" />
    <path d="M9.5 9.5L13 13" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// S2 — Radar empty-state illustration (1c at 72×72, 1f at 64×64; same
// viewBox). `#BFDBFE` is used only here.
export const RadarEmptyGlyph = ({ size = 72, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden="true" {...rest}>
    <circle cx="36" cy="36" r="34" fill="#E8F1FF" />
    <circle cx="36" cy="36" r="22" fill="none" stroke="#BFDBFE" strokeWidth="2" />
    <circle cx="36" cy="36" r="11" fill="none" stroke="#BFDBFE" strokeWidth="2" />
    <circle cx="36" cy="36" r="3" fill="#2283FF" />
    <circle cx="47" cy="25" r="4" fill="#2283FF" />
  </svg>
);

// S3 — Radar mark, white, on the blue snapshot tile (1n at 18×18,
// 1o at 16×16).
export const RadarMarkGlyph = ({ size = 18, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden="true" {...rest}>
    <circle cx="36" cy="36" r="30" fill="none" stroke="#fff" strokeWidth="5" />
    <circle cx="36" cy="36" r="14" fill="none" stroke="#fff" strokeWidth="5" />
    <circle cx="47" cy="25" r="6" fill="#fff" />
  </svg>
);

// S4 — Verified shield (1l profile "Verified" badge; 1n conversation
// rows). Rendered 9×11.
export const VerifiedShieldGlyph = ({ width = 9, height = 11, ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 12 14" aria-hidden="true" {...rest}>
    <path d="M6 1l5 2v4c0 3.5-2.5 5.5-5 6-2.5-.5-5-2.5-5-6V3z" fill="#047857" />
    <path d="M4 7l1.5 1.5L8.5 5.5" stroke="#fff" strokeWidth="1.4" fill="none" strokeLinecap="round" />
  </svg>
);

// ── Unicode design characters (DESIGN-SPEC §3 table) ─────────────────
// Copy rule as much as component rule: surface builders must render
// these exact codepoints (never ASCII stand-ins like "..." or "x").
export const GLYPH = {
  middot: "·", // · universal separator
  ellipsisMenu: "⋯", // ⋯ overflow-menu trigger
  close: "×", // × modal/drawer close
  caretDown: "▾", // ▾ sort & label dropdown caret
  chevronLeft: "‹", // ‹ back (mobile)
  chevronRight: "›", // › row forward chevron
  check: "✓", // ✓ selected segment / checkbox ticks
  plus: "+",
  bang: "!", // danger confirm icon glyph
  emDash: "—", // —
  apostrophe: "’", // ’
  quoteOpen: "“", // “
  quoteClose: "”", // ”
  ellipsis: "…", // … "Move players to…"
  lessOrEqual: "≤", // ≤ (request-title data)
  euro: "€", // €
};
